module.exports = __webpack_public_path__ + "static/media/users.0af831c6.png";